let serverBaseUrl;
let cosBucket;
let cosRegion;
let wechatAppId;
let wechatRedirectUrl;
let wechatWorkAppId;
let wechatWorkLoginSuiteId;
if (process.env.REACT_APP_DEPLOY_ENV === 'production') {
  serverBaseUrl = 'https://api.heyban.cn';
  cosBucket = 'hb-prod-1253834350';
  cosRegion = 'ap-nanjing';
  wechatRedirectUrl = 'https://heyban.cn';
  wechatAppId = 'wx5365b1ff131f2ea4';
  wechatWorkAppId = 'ww5f6603d6b96e4b8b';
  wechatWorkLoginSuiteId = 'wwec8dbe466a75894e';
} else if (process.env.REACT_APP_DEPLOY_ENV === 'staging') {
  serverBaseUrl = 'http://api.dev.heyban.cn';
  cosBucket = 'hb-dev-1253834350';
  cosRegion = 'ap-nanjing';
  wechatRedirectUrl = 'http://hb-staging-1253834350.cos-website.ap-nanjing.myqcloud.com';
  wechatAppId = 'wxb1bed297753eaadc';
  wechatWorkAppId = 'wwf68b16dc0365c1e4';
  wechatWorkLoginSuiteId = 'wwec8dbe466a75894e';
} else {
  serverBaseUrl = 'http://localhost:1337';
  cosBucket = 'hb-dev-1253834350';
  cosRegion = 'ap-nanjing';
  wechatRedirectUrl = 'http://192.168.144.101:3000';
  wechatAppId = 'wxb1bed297753eaadc';
  wechatWorkAppId = 'ww836832e986d2240d';
  wechatWorkLoginSuiteId = 'wwec8dbe466a75894e';
}

const PROMOTION_DISCOUNT = 0.9;
const WECHAT_APP_ID = wechatAppId;
const WECHAT_REDIRECT_URL = wechatRedirectUrl;
const WECHAT_WORK_APP_ID = wechatWorkAppId;
const WECHAT_WORK_LOGIN_SUITE_ID = wechatWorkLoginSuiteId;
const SERVER_BASE_URL = serverBaseUrl;
const COS_BUCKET = cosBucket;
const COS_REGION = cosRegion;
const BASE_PATH = SERVER_BASE_URL.replace(/^.*\/\/[^/]*(.*)[^?#]*.*$/, '$1');
const SERVER_HOST_NAME = SERVER_BASE_URL.replace(/^(.*\/\/[^/?#]*).*$/, '$1');

const ACCESS_TOKEN_KEY = 'accessToken';
const ACCESS_TOKEN_VERSION_KEY = 'accessTokenVersion';
const ACCESS_TOKEN_VERSION = '1';

const POSITION_GAP = 65535;
const ACTIVITIES_LIMIT = 50;
const NOTIFICATIONS_PAGE_SIZE = 100;
const ARCHIVE_CARDS_PAGE_SIZE = 50;
const BOARD_ACTIONS_PAGE_SIZE = 50;
const CARDS_ME_PAGE_SIZE = 10;
const AONNOUCEMENT_LIMIT = 10;
export default {
  WECHAT_WORK_LOGIN_SUITE_ID,
  CARDS_ME_PAGE_SIZE,
  BASE_PATH,
  SERVER_BASE_URL,
  SERVER_HOST_NAME,
  ACCESS_TOKEN_KEY,
  ACCESS_TOKEN_VERSION_KEY,
  ACCESS_TOKEN_VERSION,
  POSITION_GAP,
  ACTIVITIES_LIMIT,
  COS_BUCKET,
  COS_REGION,
  NOTIFICATIONS_PAGE_SIZE,
  ARCHIVE_CARDS_PAGE_SIZE,
  BOARD_ACTIONS_PAGE_SIZE,
  WECHAT_REDIRECT_URL,
  WECHAT_APP_ID,
  AONNOUCEMENT_LIMIT,
  WECHAT_WORK_APP_ID,
  PROMOTION_DISCOUNT,
};
